import { useEffect, useState } from 'react'
import { approveTenantSuperadminAccess } from '@/services'
import { AppButton } from '@/components/platform/primitives'
import { Icon } from '@/components/platform/Icon'

// Solo lee. Borrar el token de la barra de direcciones es un efecto y vive en el
// useEffect de abajo: hacerlo mientras se renderiza no esta garantizado, React
// puede descartar y repetir un render.
function readTokenFromHash(): string {
  if (typeof window === 'undefined') return ''
  const hash = window.location.hash.replace(/^#/, '')
  return new URLSearchParams(hash).get('token') || ''
}

export function SuperadminApprovalPage() {
  const [token] = useState(readTokenFromHash)

  // El token de acceso no debe quedar en la URL ni en el historial.
  useEffect(() => {
    if (token) window.history.replaceState(null, '', window.location.pathname)
  }, [token])

  const [status, setStatus] = useState<'idle' | 'loading' | 'approved' | 'error'>(token ? 'idle' : 'error')
  const [message, setMessage] = useState(token ? 'Confirma para generar el acceso superadmin.' : 'Link inválido o sin token.')
  const [url, setUrl] = useState('')

  const approve = async () => {
    try {
      setStatus('loading')
      const result = await approveTenantSuperadminAccess(token)
      setUrl(result.url)
      setStatus('approved')
      setMessage('Acceso aprobado. Abrí el admin del tenant para continuar.')
    } catch (error: any) {
      setStatus('error')
      setMessage(error?.message || 'No se pudo aprobar el acceso.')
    }
  }

  return (
    <div className="auth-page" style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: 'var(--bg)', padding: 24 }}>
      <div className="card" style={{ width: 'min(460px, 100%)' }}>
        <div className="card-body col gap-4" style={{ textAlign: 'center', alignItems: 'center' }}>
          <div className="emoji"><Icon name="shield" size={28} /></div>
          <div>
            <h1 style={{ margin: 0, fontSize: 24 }}>Aprobar superadmin</h1>
            <p className="muted" style={{ marginTop: 8 }}>{message}</p>
          </div>
          {status === 'idle' ? <AppButton variant="primary" icon="shield" onClick={approve}>Autorizar acceso</AppButton> : null}
          {status === 'loading' ? <AppButton variant="secondary" disabled>Autorizando...</AppButton> : null}
          {status === 'approved' ? <AppButton variant="primary" icon="external" onClick={() => window.location.assign(url)}>Abrir admin</AppButton> : null}
          {status === 'error' ? <AppButton variant="secondary" onClick={() => window.location.assign('/login')}>Ir al panel</AppButton> : null}
        </div>
      </div>
    </div>
  )
}
